var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20557_204538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47955 12.65C8.50171 12.7052 8.54023 12.7524 8.58995 12.7851C8.63968 12.8178 8.69821 12.8345 8.7577 12.833C8.81719 12.8314 8.8748 12.8117 8.92278 12.7765C8.97076 12.7413 9.00682 12.6923 9.02613 12.636L12.8178 1.55266C12.8365 1.50098 12.84 1.44504 12.8281 1.3914C12.8161 1.33776 12.7891 1.28864 12.7503 1.24978C12.7114 1.21092 12.6623 1.18393 12.6086 1.17197C12.555 1.16001 12.4991 1.16358 12.4474 1.18225L1.36405 4.97391C1.30775 4.99322 1.25871 5.02928 1.2235 5.07726C1.1883 5.12524 1.16861 5.18285 1.16709 5.24234C1.16556 5.30183 1.18228 5.36037 1.21498 5.41009C1.24768 5.45981 1.29481 5.49833 1.35005 5.5205L5.97588 7.3755C6.12211 7.43404 6.25498 7.5216 6.36646 7.63288C6.47794 7.74416 6.56573 7.87687 6.62455 8.023L8.47955 12.65Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7479 1.25195L6.36621 7.63304",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20557_204538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b5a235295f1f0b2c2e6fe644afabae32.svg";
export { ForwardRef as ReactComponent };